const getAccountReducer = state => state.account;

export default {
  drawerActive: store => !!getAccountReducer(store).drawerActive,
  initialized: store => !!getAccountReducer(store).initialized,
  miniCashierDrawerActive: store =>
    !!getAccountReducer(store).miniCashierDrawerActive,
  rewardDrawerActive: store => !!getAccountReducer(store).rewardDrawerActive
};
